
import Cropper from 'cropperjs';

export default {
  name: 'ImageCropper',

  props: {
    imageToCrop: {
      type: String,
      default: '',
    },
    cropperActive: Boolean,
  },

  data(): Record<string, unknown> {
    return {
      cropper: (undefined as unknown) as Cropper,
      imageToCropTemplateEl: (undefined as unknown) as HTMLImageElement | HTMLCanvasElement,
      croppedImage: (undefined as unknown) as string,
    };
  },

  watch: {
    imageToCrop(): void {
      this.cropperActive ? this.initializeCropper() : null;
    },
  },

  mounted(): void {
    this.initializeCropper();
  },

  methods: {
    initializeCropper(): void {
      if (!this.imageToCrop) return;

      setTimeout(() => {
        this.imageToCropTemplateEl = (this.$refs.cropperPreview as HTMLImageElement) ?? new Image();

        this.cropper = new Cropper(this.imageToCropTemplateEl, {
          zoomable: false,
          scalable: false,
          aspectRatio: 1,
          viewMode: 3,
          ready: (): void => {
            this.cropImage();
          },
        });
      });
    },

    cropImage(): void {
      if (!this.cropper) return;

      const croppedImage: HTMLCanvasElement = this.cropper?.getCroppedCanvas();
      this.croppedImage = croppedImage.toDataURL('image/*');
    },

    passCroppedImage(): void {
      if (!this.croppedImage) return;

      this.cropImage();

      this.$emit('passCroppedImage', this.croppedImage.split('base64,')[1]);
    },

    changeUploadedImage(): void {
      if (!this.croppedImage) return;

      this.$emit('changeUploadedImage');

      this.croppedImage = false;
    },
  },
};
